import { atomWithReset } from 'jotai/utils';
import type { BerthAssignment } from '@/api/ui/requests';

export const selectedBerthAtom = atomWithReset<BerthAssignment | null>(null);
